<!--suppress ALL -->
<template>
  <div class="notification filter-notif" :class="className">
    <template v-if="$scopedSlots.default || $slots.default">
      <slot></slot>
    </template>
    <template v-else-if="skipDetailSearch">
      <p class="title is-spaced is-6">
        {{$t('text.here_your_result')}}
      </p>
      <p class="subtitle is-6">
        {{$t('text.reset_search')}}
      </p>
    </template>
    <ul v-else class="menu-list">
      <li class="text-mute" v-for="(word, index) in notifWords"
          :key="`filter-notif-${index}`">{{word}}
      </li>
    </ul>
    <template v-if="$scopedSlots.btSearch || $slots.btSearch">
      <slot name="btSearch"></slot>
    </template>
    <router-link v-else :to="$route.path" @click.native="$emit('on-back-to')"
                 class="button is-small is-info">{{$t('button.reset_search')}}
    </router-link>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'annotation';
  import {isNil} from 'lodash';

  @Component
  export default class NotificationSearch extends Vue {

    @Prop({default: null})
    public customWords: Array<string>;

    @Prop({default: {}})
    public maskText: any;

    @Prop({default: {}})
    public maskValue: any;

    @Prop({default: true, type: Boolean})
    public skipDetailSearch: boolean;

    @Prop({default: false, type: Boolean})
    public forceShow: boolean;

    public get className() {
      const isHidden: any = Object.keys(this.$route.query).length === 0 && !this.forceShow;

      return {'is-hidden': isHidden};
    }

    public get notifWords(): Array<any> {
      const {query} = this.$route;
      if (!isNil(this.customWords)) {
        return this.customWords;
      }

      let alertWords = [];
      for (let key in query) {
        const value = query[key];
        alertWords.push(this.$t('label.search_query_param', {
          key: this.maskText[key] || key,
          value: this.maskValue[key] || value
        }));
      }

      return alertWords;
    }
  }
</script>

<style lang="scss">
  @import "../../style/variables_function";

  .notification.filter-notif {
    @include b_sh_def;
    background-color: white;
    border-radius: 6px;
    > p.title {
      margin-bottom: .5rem !important;
    }
    > p.subtitle {
      margin-bottom: 1rem;
      & + a.button {
        margin-top: 0;
      }
    }
    a:not(.button), span, li {
      font-weight: 300;
    }
    > a.button {
      margin-top: 1rem;
    }
    ul.menu-list li {
      &:not(:last-child) {
        margin-bottom: .5rem;
      }
      &::before {
        margin-right: .5rem;
        content: "*";
        color: $red;
      }
    }
  }
</style>
